import type { ComponentConfig } from "@puckeditor/core"

export type HeaderLink = { label: string; href: string }

export type HeaderProps = {
  logoText: string
  logoSrc: string
  links: HeaderLink[]
  ctaLabel: string
  sticky: "yes" | "no"
}

export const Header: ComponentConfig<HeaderProps> = {
  fields: {
    logoText: { type: "text", label: "Logo text", contentEditable: true },
    logoSrc: { type: "text", label: "Logo image URL", contentEditable: true },
    links: {
      type: "array",
      arrayFields: {
        label: { type: "text", label: "Label", contentEditable: true },
        href: { type: "text", label: "Link", contentEditable: true },
      },
      defaultItemProps: { label: "Menu item", href: "#" },
      getItemSummary: (l) => l?.label || "Link",
    },
    ctaLabel: { type: "text", label: "CTA label", contentEditable: true },
    sticky: {
      type: "select",
      options: [
        { label: "Sticky", value: "yes" },
        { label: "Static", value: "no" },
      ],
    },
  },

  defaultProps: {
    logoText: "Your Brand",
    logoSrc: "",
    links: [],
    ctaLabel: "",
    sticky: "yes",
  },

  render: ({ logoText, logoSrc, links, ctaLabel, sticky, puck }) => (
    <header
      style={{
        background: "#fff",
        borderBottom: "1px solid #e5e7eb",
        ...(sticky === "yes" ? { position: "sticky" as const, top: 0, zIndex: 50 } : {}),
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px", height: 64, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 24 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {logoSrc && <img src={logoSrc} alt={logoText} style={{ height: 28 }} />}
          <span style={{ fontWeight: 800, fontSize: "1.125rem" }}>{logoText}</span>
        </div>
        <nav style={{ display: "flex", gap: 24, alignItems: "center" }}>
          {(links || []).map((l, i) => (
            <a
              key={i}
              href={l.href}
              style={{ fontSize: 15, fontWeight: 500, color: "#374151", textDecoration: "none" }}
              // RSC render passes no event handlers: functions cannot cross the
              // client boundary. In the editor the links are inert instead.
              onClick={puck?.isEditing ? (e) => e.preventDefault() : undefined}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div style={{ minWidth: 80, textAlign: "right" }}>
          {ctaLabel && (
            <button
              style={{
                padding: "8px 16px",
                background: "var(--site-accent, #7c3aed)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              {ctaLabel}
            </button>
          )}
        </div>
      </div>
    </header>
  ),
}
